import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import InlinePrompt from "@Shared/components/general/inline-prompt";
import ManageEmailCalendarsModal from "./manage-email-calendars-modal";
import { showToast } from "@Shared/@Utils/constants";
import { mapActions } from "vuex";
import { Fragment } from "vue-fragment";
import { UPDATE_DEFAULT_EMAIL, DELETE_SYNCED_EMAIL } from "@Broker/@Modules/settings/store/settings-actions";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "EmailActionsDropdown",
  components: {
    InlinePrompt,
    ManageEmailCalendarsModal,
    Fragment
  },
  props: {
    defaultAccount: {
      type: Boolean,
      required: true
    },
    accountId: {
      type: String,
      required: true
    },
    numberOfSyncedEmails: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      preventDropdownClose: false,
      loading: false
    };
  },
  computed: {
    disableDeleteEmail() {
      return this.defaultAccount && this.numberOfSyncedEmails !== 1;
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions("SettingsStore", [UPDATE_DEFAULT_EMAIL, DELETE_SYNCED_EMAIL])), {}, {
    async updateDefaultEmail() {
      this.$refs.emailActionsDropdown.hide(true);
      this.UPDATE_DEFAULT_EMAIL(this.accountId);
    },
    async deleteSyncedEmail() {
      this.loading = true;
      try {
        await this.DELETE_SYNCED_EMAIL(this.accountId);
        showToast("success", "deleteSyncedEmail");
      } catch (e) {
        this.inlinePromptHide();
        this.$refs.emailActionsDropdown.hide(true);
      } finally {
        this.loading = false;
      }
    },
    showManageCalendarsModal() {
      this.$refs.manageEmailCalendarsModal.openModal();
    },
    hideDropdown($event) {
      if (this.preventDropdownClose) $event.preventDefault();
    },
    inlinePromptHide() {
      this.preventDropdownClose = false;
    },
    inlinePromptShown() {
      this.preventDropdownClose = true;
    }
  })
});